import React from 'react';
import FormItemEditorRender from './FormItemEditorRender';
import StringUtil from '../../utils/StringUtil';
import CommandArgFuncUtil from '../../utils/CommandArgFuncUtil';
import CommonUtil from '../../utils/CommonUtil';
import CommandResolver from '../../utils/CommandResolver';
import GOTUtil from '../../utils/GOTUtil';
require('../../styles/FormItemRender.css');
export default class FormItemStringRender extends FormItemEditorRender
{
	constructor(props) {
		super(props);
	}
	
	testDragStart(e)
	{
		//var data = e.dataTransfer;
		let billData = {};
		let billTable = {};
		for(let key in this.props.rowData)
		{
			if(key.indexOf(".")!=-1)
			{
				let keyArr = key.split(".");
				let subKey = keyArr[keyArr.length-1];
				// billTable[this.props.column.name] = this.props.rowData[key];
				let dataSourceFields = this.props.group.mainSource.xml.FormDataSourceFields;
				let caseUp = StringUtil.convertToEachFirstUpperCase(subKey);
				for(let index in dataSourceFields){
					if(dataSourceFields[index].qname == "FormDataSourceField" && dataSourceFields[index].name == caseUp){
						let fieldLabel = GOTUtil.getFinalValue(dataSourceFields[index],this.props.group.formDataSources.formModule.props.xml,"Label"); 
						billTable[fieldLabel] = this.props.rowData[key];
					};
				}
			}
		}
		billData["billTable"] = billTable;

		let groups = this.props.group.formDataSources.groups;
		let LineGroup = null;
		for(let key in groups)
		{
			let _group = groups[key];
			if(_group.linkGroup == this.props.group)
			{
				LineGroup = _group;break;
			}
		}

		if(LineGroup)
		{
			let billLines = [];
			let length = LineGroup.records?LineGroup.records.length:0;
			for(let i=0;i<length;i++)
			{
				let _record = LineGroup.records[i];
				let _lineItem = {};
				for(let key in _record)
				{
					if(key.indexOf(".")!=-1)
					{
						let keyArr = key.split(".");
						let subKey = keyArr[keyArr.length-1];
						let dataSourceFields = LineGroup.mainSource.xml.FormDataSourceFields;
						let caseUp = StringUtil.convertToEachFirstUpperCase(subKey);
						for(let index in dataSourceFields){
							if(dataSourceFields[index].qname == "FormDataSourceField" && dataSourceFields[index].name == caseUp){
								let fieldLabel = GOTUtil.getFinalValue(dataSourceFields[index],this.props.group.formDataSources.formModule.props.xml,"Label"); 
								_lineItem[fieldLabel] = _record[key];
							};
						}
					}
				}
				billLines.push(_lineItem)
			}
			billData["billLines"] = billLines;
		}


		/*data.setData("purch",JSON.stringify(
			{content:purchData,name:this.props.rowData[this.props.group.groupAlias+".purchId"]}
		));*/
		
		let dragHandlerFunc = this.props.column.dragStartHandler;
		dragHandlerFunc(e,billData);
		
	}

	render()
	{
		let _display = "none";
		let _value = this.props.rowData[this.props.dataField];
		_value = this.getDisplay(_value);
		_display = this.forLookup?"none":(this.props.group == undefined ? "none":(this.props.group
			.isCurrentDataFieldModified(this.props.rowData,this.props.dataField)?"block":"none"));
		
		let _style = {padding:"3px"};
		_style.textAlign = this.props.textAlign.toLowerCase();
		let _displayStyle = this.props.displayStyle;
		if(_displayStyle && _displayStyle.Color)_style.color = _displayStyle.Color;
		if(this.props.cssStyle)
		{
			Object.assign(_style,this.props.cssStyle);
		}
		if(_display == "block")_style.backgroundColor = "#f8e8b7";

		let clientStyle = CommonUtil.getClientLayerRowStyles(window.formModuleInstance,null,"getDataGridStyle_"+this.props.gridXml.name,[this.props.rowData,this.props.dataField]);
		
		if(clientStyle)
		{
			_style = Object.assign(_style,clientStyle);
		}

		let rowStyles = this.getRowStyles();
		if(rowStyles)
		{
			for(let i = 0;i<rowStyles.length;i++)
			{
				let rowStyle = rowStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,rowStyle.recordCondition);
				if(bool)
				{
					if(rowStyle.color != -1)
						_style.color = "#"+StringUtil.toColorStyleString(rowStyle.color);//rowStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(rowStyle.backgroundColor != -1)
						_style.backgroundColor = "#"+StringUtil.toColorStyleString(rowStyle.backgroundColor);//rowStyle.backgroundColor.toString(16);
					if(rowStyle.fontSize != -1)
						_style.fontSize = rowStyle.fontSize;
					if(rowStyle.fontFamily != null)
						_style.fontFamily = rowStyle.fontFamily;
					if(rowStyle.fontWeight != null)
						_style.fontWeight = rowStyle.fontWeight;
				}
			}
		}

		let colStyles = this.getEditorStyles();
		if(colStyles)
		{
			for(let i = 0;i<colStyles.length;i++)
			{
				let colStyle = colStyles[i];
				let bool = this.props.group.analysisConditionSingleRecord1(this.props.rowData,colStyle.recordCondition);
				if(bool)
				{
					if(colStyle.color != -1)
						_style.color = "#"+StringUtil.toColorStyleString(colStyle.color);//colStyle.color.toString(16);//原来是break 说明多个条件之间是或 现在改成了无条件覆盖
					if(colStyle.backgroundColor != -1)
						_style.backgroundColor = "#"+StringUtil.toColorStyleString(colStyle.backgroundColor);//colStyle.backgroundColor.toString(16);
					if(colStyle.fontSize != -1)
						_style.fontSize = colStyle.fontSize;
					if(colStyle.fontFamily != null)
						_style.fontFamily = colStyle.fontFamily;
					if(colStyle.fontWeight != null)
						_style.fontWeight = colStyle.fontWeight;
				}
			}
		}

		if(this.props.isMutiRow)
		{
			_style.whiteSpace = "pre-wrap";
			_style.wordWrap = "break-word";
			_style.wordBreak = "break-all";
		}
		let dragHandlerFunc = null;
		if(this.props.column && this.props.column.dragStartHandler)
		{
			if(typeof(this.props.column.dragStartHandler) == "function")
			{
				dragHandlerFunc = this.props.column.dragStartHandler;
			}
		}
		if(this.props.trim){
			if(this.props.trim == 'None'){
				_style.whiteSpace = "pre-wrap";
			}
		}

		/*if(this.props.rowData && this.props.rowData["EquipmentTable.sysActive"] == false)
		{
			_style.backgroundColor = "rgb(255, 255, 153)";
		}*/
		let _clsName = "gongqi_render_select";if(_display == "block")_clsName+=" gongqi_render_version0";
		if(_style.backgroundColor)_clsName+=" gongqi_render_back";
		if(dragHandlerFunc)
		{
			return(
				<div draggable="true" onDragStart={this.testDragStart.bind(this)} className={_clsName} ref={ node => this.componentLabel = node } style={_style}>
					{_value}
					<i ref={node => this.modifiedTag = node} className="fa fa-sort-desc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-3px",right:"0px",transform:'rotate(224deg) scale(1.5)',zIndex:"100",display:_display}}></i>
				</div>
			);
		}
		else
		{
			return(
				<div className={_clsName} ref={ node => this.componentLabel = node } style={_style}>
					{_value}
					<i ref={node => this.modifiedTag = node} className="fa fa-sort-desc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-3px",right:"0px",transform:'rotate(224deg) scale(1.5)',zIndex:"100",display:_display}}></i>
				</div>
			);
		}
	}
}


// WEBPACK FOOTER //
// ./src/formItem/renders/FormItemStringRender.js